import '../css/app.css';
import '../../vendor/power-components/livewire-powergrid/dist/powergrid.js';

import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

window.flatpickr = flatpickr; // PowerGrid requires this

import './bootstrap';
